import LZString from "lz-string";

export const searchDebounceWait = 500;

export function clone<T>(obj: T) {
    return $.extend({}, obj) as T;
}

export const events = {
    register: function (event, fn) {
        $(document).on(event, fn);
    },
    fire: function (event, args?) {
        $(document).trigger(event, args);
    },
    pageDoneLoading: "pageDoneLoading" as "pageDoneLoading"
};

export function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export function deepCloneEverything(obj) {
    return $.extend(true, {}, obj);
}

export function toString(value, format?) {
    // format to --- for null values
    var output = value  || "---";
    if (!format || format == "-") {
        return output;
    }

    // rest of code will format dates, numbers, and currency
    var dateFormats = ["d", "D", "F", "g", "G"];
    if (dateFormats.indexOf(format) != -1) {
        value = new Date(value);
    } else {
        value = value - 0;
    }

    output = kendo.toString(value, format);

    if (!output) {
        output = 0;
        output = kendo.toString(output, format);
    }

    return output;
}

export function setLocalStorage(key, data) {
    var compressed = LZString.compressToUTF16(data);
    localStorage.setItem(key, compressed);
}

export function getLocalStorage(key) {
    return LZString.decompressFromUTF16(localStorage.getItem(key));
}

export function setSessionStorage(key, data) {
    var compressed = LZString.compressToUTF16(data);
    sessionStorage.setItem(key, compressed);
}

export function getSessionStorage(key) {
    return LZString.decompressFromUTF16(sessionStorage.getItem(key));
}

export function requireArgument(args, argumentName) {
    if (args[argumentName] === undefined) {
        throw new Error("Required argument '{0}' was not provided.".format(argumentName));
    }
    return args[argumentName];
}

export function getQueryStringValue(name) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(window.location.href);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return "";
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
